export const en = {
    'actions-title': 'Actions',
    'add-banner': 'Add a banner',
    'add-group': 'Add a group',
    aim: 'Preview ad',
    bannerAimingDisabledMessage: 'Previewing only works if your ad has passed moderation and your campaign is running',
    copy: 'Copy',
    delete: 'Delete',
    edit: 'Edit',
    'go-to-report-master': 'Go to Report Wizard',
    'internal-tool-title': 'Internal tools',
    moderate: 'Send to moderation',
    moderateAccept: 'Accept moderation',
    moderateAcceptBannersAdditions: 'Moderation: accept callouts',
    moderateByClient: 'Send to moderation',
    notEditable: 'Editing is not available',
    'regions-transform': 'Configure display regions',
    remoderate: 'Re-moderate',
    remoderateBannersAdditions: 'Re-moderate callouts',
    resume: 'Activate',
    sendBK: 'Send to banner system (BS)',
    'show-params': 'View parameters',
    suspend: 'Stop'
};
